import { useCallback, useState } from 'react';
import { trpClient } from '../client/trpClient';
import { downloadBlob } from '../utils/download';
import { displayRfqId } from '../utils/rfqIdentity';

export type ExportKind = 'sourcing-summary' | 'smart-bom';

/**
 * The wizard header's two downloads (Sourcing Summary, Smart BOM). One request
 * may be in flight at a time so the header can show which item is busy, and a
 * failed export leaves the menu usable rather than stranding it on a spinner.
 */
export const useWizardExport = (rfqId?: string) => {
  const [exporting, setExporting] = useState<ExportKind | null>(null);

  const exportFile = useCallback(
    async (kind: ExportKind) => {
      if (!rfqId || exporting) return;
      setExporting(kind);
      try {
        if (kind === 'sourcing-summary') {
          downloadBlob(await trpClient.downloadSourcingSummary(rfqId), `${displayRfqId(rfqId)}-Sourcing-Summary.pdf`);
        } else {
          downloadBlob(await trpClient.downloadSmartBom(rfqId), `${displayRfqId(rfqId)}-SmartBOM.xlsx`);
        }
      } catch (e) {
        console.error(`Failed to export ${kind}:`, e);
      } finally {
        setExporting(null);
      }
    },
    [rfqId, exporting],
  );

  return { exporting, exportFile };
};

export default useWizardExport;
